// extracted by mini-css-extract-plugin
export default {"intro":"xjKOp8U0GYpOhSy3j3bv"};